import React from 'react';
import {Outlet} from 'react-router-dom';
import { Container,Typography } from '@mui/material';
import Comunication from './Comunication';
import ComunicationPhone from './ComunicationPhone';
import ComunicationEmail from './ComunicationEmail';

function History() {
  return (
    <>
        <Comunication/>
        <ComunicationPhone/>
        <ComunicationEmail/>
        <Container className='missionMain' style={{marginTop:95, marginBottom:20,color:'#3b4990'}}>
          <Typography variant='h4' component='h4' sx={{marginTop:1, marginBottom:1}}>Tarihimiz</Typography>
          <Typography variant='body2' component='p'>
            2015 yılında Ali Metin tarafından kurulduk. Köklü değerlerimiz ve ilkelerimizle “Türkiye’nin Önemli Kurumsal Emlak Ofisi” unvanını taşımaktayız. 
            Yıllardı sektörde iz bırakan birçok yeniliği sığdırdık.
            <br />
            <br />
            Kurulduğumuz ilk günden beri asıl hedefimiz, müşterilerimize güvenilir, şeffaf, doğru ve kazançlı yatırım fırsatları sunmaktır. 
            Müşterilerimizi anlamak, ihtiyaçlarını analiz etmek ve onların bütçeleri beklentileri doğrultusunda birikimlerini kazançlı yatırımlara dönüştürmek esas hedefimizdir.
            <br />
            <br />
            Yıllardır sunduğumuz hizmetlerle farklılaşmak için çalışıyoruz. Müşterilerimize “gayrimenkul satın alma şartı gözetmeksizin”, 
            ücretsiz özel danışmanlık hizmeti veriyoruz.
            <br />
            <br />
            Yatırım yapmayı düşündükleri bölgelerdeki gayrimenkulü satın almadan önce, yerinde göstererek, tüm resmi birimlerden teyidini yaptırarak, yine müşterinin isteğine bağlı olarak 
            kadastro müdürlüğünden bir memura, beğendiği yeri tekrar ölçtürerek şeffaf bir şekilde değerlendirme imkânı sunuyoruz ve yatırımcılarımıza güvenli ve sorunsuz bir kazanç sunuyoruz. 
            <br />
            Önceliğimiz her zaman güven kazanmak ve müşterilerimize kazançlı bir yatırım sunmak. Bu anlayışla her zaman müşterilerimizi doğru olan yatırıma yönlendirmeyi hedefliyoruz. 
            Geçmişimizde en değerli sermayemiz müşterilerimizle kurduğumuz uzun soluklu ve güven temeline dayanan ilişkiler oldu. 
            Her zaman birlikte kazandık, birlikte geleceğe adım attık
            <br />
            <br />
            Sağlam adımlarla gelişerek, bilgi ve deneyimimizi artırarak büyüdük. Emlakçın olarak ilk kurulduğumuz yıllarda sadece iki bölgede 
            (Çatalca ve Sultangazi) faaliyet göstermekteyiz. 10 yılı aşkın bir süredir tüm müşterilerimiz ve çalışanlarımız, Emlakçın ailesinin bir üyesi oldu. 
            Güvenilirlik, şeffaflık, dürüstlük ve içten hizmet anlayışıyla her zaman birikimlerinizi kazançlı yatırıma dönüştürmek için çalıştık.
            <br />
            <br />
            Siz de geleceğiniz için sağlam ve kazançlı bir adım atmak isterseniz, Emlakçın ailesi her zaman yanınızda olacaktır.
          </Typography>
        </Container>
        <Outlet/>
    </>

  )
}

export default History;